/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { CommunityResponse } from '../../models/community-response';

export interface CommunityControllerGetAll$Params {
  query?: string;
  tag?: string;
  public_flag?: boolean;
  creator_id?: number;
  ids?: Array<number>;
  limit: number;
  skip: number;
}

export function communityControllerGetAll(http: HttpClient, rootUrl: string, params: CommunityControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CommunityResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, communityControllerGetAll.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('tag', params.tag, {});
    rb.query('public_flag', params.public_flag, {});
    rb.query('creator_id', params.creator_id, {});
    rb.query('ids', params.ids, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: CommunityResponse;
      }>;
    })
  );
}

communityControllerGetAll.PATH = '/community';
